import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const DescriptionIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.375 17.7752C3.075 17.7752 2.8125 17.6627 2.5875 17.4377C2.3625 17.2127 2.25 16.9502 2.25 16.6502V5.4002C2.25 5.1002 2.3625 4.8377 2.5875 4.6127C2.8125 4.3877 3.075 4.2752 3.375 4.2752H10.9688L9.84375 5.4002H3.375V16.6502H14.625V10.1252L15.75 9.0002V16.6502C15.75 16.9502 15.6375 17.2127 15.4125 17.4377C15.1875 17.6627 14.925 17.7752 14.625 17.7752H3.375ZM12.4125 4.4252L13.2188 5.2127L7.875 10.5377V12.1502H9.46875L14.8312 6.7877L15.6188 7.5752L9.9375 13.2752H6.75V10.0877L12.4125 4.4252ZM15.6188 7.5752L12.4125 4.4252L14.2875 2.5502C14.5 2.3377 14.7656 2.23145 15.0844 2.23145C15.4031 2.23145 15.6687 2.34395 15.8812 2.56895L17.4562 4.1627C17.6687 4.3877 17.775 4.65332 17.775 4.95957C17.775 5.26582 17.6625 5.5252 17.4375 5.7377L15.6188 7.5752Z" fill="#434649" fillOpacity="0.85"/>
    </svg>
  </SvgWrapper>
);